import Api from '@/services/Api'

export default {

  // Método que llama a la url para crear un chat
  getCovidPatientAlarms () {
    return Api().get("/covid-patient-alarms");
  },
  updateCovidPatientAlarm (params) {
    return Api().put("/covid-patient-alarms",params);
  },
  addCovidPatientAlarm (params) {
    return Api().post("/covid-patient-alarms",params);
  },
  getCovidPatientAlarm (params) {
    return Api().get("/covid-patient-alarms/"+params);
  },
  getCovidPatientAlarmByPatient (params) {
    return Api().get("/covid-patient-alarms-by-patient/"+params);
  },
  deleteCovidPatientAlarm (params) {
    return Api().delete("/covid-patient-alarms/"+params);
  },
  sendCovidPatientAlarmMail (params) {
    return Api().get("/covid-patient-alarms-send-mail/"+params);
  },
  generateReport(params) {
    return Api().get("/generate-report/"+params);
  },
  generateEvolutionReport(params) {
    return Api().get("/generate-report-evolution/"+params);
  },
  generateDoctorAsistantReport() {
    return Api().get("/generate-report-doctor/");
  },
  hasCovidAlarmToday(params) {
    return Api().get("/has-covid-alarm-today/"+params);
  },
}



// WEBPACK FOOTER //
// ./src/services/CovidPatientAlarmService.js